import classNames from "classnames";
import { IconChevron } from "../IconChevron";

export function IconExpand(props) {
    const classes = classNames("expandIcon", props.className);
    return <IconChevron {...props} className={classes} />;
}
